export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";